/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type PolicyPremiumFundingDetailsDto = {
    /**
     * Premium funding quote UUID
     */
    id: string;
    /**
     * Payment frequency used for premium funding
     */
    paymentFrequency: PolicyPremiumFundingDetailsDto.paymentFrequency;
    /**
     * Policy amount used for funding quote
     */
    policyAmount: number;
    /**
     * Policy issue date
     */
    policyIssueDate: string;
    /**
     * Policy start date
     */
    policyStartDate: string;
    /**
     * Premium funding payment start date
     */
    paymentStartDate: string;
    /**
     * First instalment amount
     */
    firstInstalment?: number | null;
    /**
     * First payment due date
     */
    firstPaymentDueDate?: string | null;
    /**
     * Number of payments
     */
    numberOfPayments?: number | null;
    /**
     * Regular instalment amount
     */
    regularInstalment?: number | null;
    /**
     * Last regular instalment date
     */
    regularInstalmentLastDate?: string | null;
    /**
     * Flat interest rate
     */
    flatInterestRate?: number | null;
    /**
     * Annual interest rate
     */
    annualInterestRate?: number | null;
    /**
     * Total interest charges
     */
    interestCharges?: number | null;
    /**
     * Application fee
     */
    applicationFee?: number | null;
    /**
     * Total amount payable under funding plan
     */
    totalAmountPayable?: number | null;
    /**
     * Premium total from funding quote
     */
    premiumTotal?: number | null;
    /**
     * Deposit amount
     */
    depositAmount?: number | null;
};
export namespace PolicyPremiumFundingDetailsDto {
    /**
     * Payment frequency used for premium funding
     */
    export enum paymentFrequency {
        WEEKLY = 'WEEKLY',
        FORTNIGHTLY = 'FORTNIGHTLY',
        MONTHLY = 'MONTHLY',
        ANNUAL = 'ANNUAL',
    }
}

